// Static content for EISG (French primary)

export const EISG_IMG = {
  logoPdfUrl: "https://customer-assets.emergentagent.com/job_fa6b9c62-97b5-4fc7-81e3-8040206e9553/artifacts/zr37p8d7_EISG%20LOGO.pdf",
  // Johannesburg urban skyline (actual Johannesburg) — used for main hero (Joburg context)
  hero: "https://customer-assets.emergentagent.com/job_ai-governance-hub-33/artifacts/ap39f01x_1e831a09-d9dd-47c9-ad1d-ec0e26967716.jpg",
  // Cape Town authentic — Table Mountain + V&A Waterfront at sunset
  capeTown: "https://customer-assets.emergentagent.com/job_ai-governance-hub-33/artifacts/m62m27fa_209b6e46-1dc1-4e8a-905c-2942f9b6c075.png",
  // 4 diverse executives networking in formal attire
  executives: "https://customer-assets.emergentagent.com/job_ai-governance-hub-33/artifacts/yg9ro7f4_5b6c679e-9483-4fc5-8ba8-45579d4b821f.jpg",
  // EISG executive studio with AI dashboard — Programme Phare visual
  dashboard: "https://customer-assets.emergentagent.com/job_ai-governance-hub-33/artifacts/7y0elz52_69bd1193-cf47-489c-8bfc-f0c7d3b0b5b6.jpg",
  // Senior African executive with EISG plaque looking at Johannesburg skyline — flagship EISG visual
  boardroom: "https://customer-assets.emergentagent.com/job_ai-governance-hub-33/artifacts/rqeni3m5_9a8e5031-23c2-4061-a084-303fa7ba8a11.png",
  // Executive board strategy session with AI dashboards + Joburg skyline — perfect for EISG teaser / governance theme
  boardroomExec: "https://customer-assets.emergentagent.com/job_ai-governance-hub-33/artifacts/7s7dgd6f_BAORDROOM%20SETTING.png",
  bridgedatumLogo: "https://customer-assets.emergentagent.com/job_fa6b9c62-97b5-4fc7-81e3-8040206e9553/artifacts/z4xpy28i_BRIDGEDATUM.png",
};

export const PROGRAMMES = [
  {
    id: "phare",
    number: "01",
    title: "Programme Phare — Pilotage de la Transformation Digitale et de l'IA",
    short: "Pilotage",
    location: "Johannesburg",
    duration: "5 jours",
    price: "USD 2,950",
    priceUnit: "par participant",
    audience: ["CEOs", "Directeurs généraux", "Directeurs de stratégie", "Responsables transformation digitale", "Responsables innovation", "Cadres publics", "Dirigeants institutionnels"],
    description: "Un programme intensif de 5 jours conçu pour les dirigeants et cadres supérieurs qui doivent comprendre, gouverner et exécuter une transformation digitale et IA avec clarté, méthode et impact.",
    outcomes: [
      "Vision stratégique de l'IA",
      "Diagnostic de maturité digitale et IA",
      "Portefeuille de cas d'usage prioritaires",
      "Cadre de gouvernance et de gestion des risques",
      "Feuille de route de transformation",
      "Plan d'action à 90 jours",
    ],
    cta: "S'inscrire au Programme Phare",
    cohort: "Août / Septembre 2026",
    // Joburg context — EISG executive studio with dashboard
    image: "https://customer-assets.emergentagent.com/job_ai-governance-hub-33/artifacts/7y0elz52_69bd1193-cf47-489c-8bfc-f0c7d3b0b5b6.jpg",
  },
  {
    id: "command",
    number: "02",
    title: "AI Executive Command — Sommet décisionnel des dirigeants",
    short: "Commandement",
    location: "Cape Town",
    duration: "3 jours premium",
    price: "USD 3,900",
    priceUnit: "par participant",
    audience: ["Board members", "CEOs", "Présidents et Vice-Présidents", "Ministres", "Directeurs généraux", "Country Managers", "Executive Committee members", "Hauts décideurs publics et privés"],
    description: "Un sommet premium pour les hauts dirigeants, membres de conseils d'administration et décideurs de haut niveau qui doivent prendre les bonnes décisions sur l'IA, la gouvernance, la transformation et la compétitivité institutionnelle.",
    outcomes: [
      "Vision exécutive de l'IA",
      "Cadre de décision stratégique",
      "Agenda de gouvernance et de risque",
      "Priorités de transformation institutionnelle",
      "Alignement du leadership",
      "Feuille de route personnelle du dirigeant",
    ],
    cta: "Rejoindre AI Executive Command",
    cohort: "Fin Novembre 2026",
    // Cape Town authentic — Table Mountain + V&A Waterfront
    image: "https://customer-assets.emergentagent.com/job_ai-governance-hub-33/artifacts/yg9ro7f4_5b6c679e-9483-4fc5-8ba8-45579d4b821f.jpg",
  },
  {
    id: "augmentees",
    number: "03",
    title: "Sessions Augmentées — Parcours Métiers IA",
    short: "Métiers",
    location: "Johannesburg",
    duration: "3 semaines",
    price: "USD 1,950",
    priceUnit: "par participant / parcours",
    audience: ["Cadres et managers fonctionnels", "Responsables RH, Finance, Juridique, Audit", "Responsables Opérations, Achats, Commercial", "Équipes data, suivi-évaluation, reporting"],
    description: "Des sessions intensives conçues pour outiller les fonctions clés de l'organisation avec des usages pratiques de l'IA générative, de l'automatisation intelligente et de la décision augmentée.",
    parcours: [
      "IA pour RH, Administration et Organisation",
      "IA pour Finance, Audit et Contrôle",
      "IA pour Commercial, Communication et Relation Client",
      "IA pour Opérations, Projets et Supply Chain",
      "IA pour Achats, Procurement et Contract Management",
      "IA pour Juridique, Risques et Conformité",
      "IA pour Suivi-Évaluation, Données et Reporting",
      "IA pour Santé, Programmes Sociaux et Développement",
      "IA pour Agriculture, Mines, Infrastructure et Secteurs Techniques",
    ],
    outcomes: [
      "Cas d'usage IA par fonction",
      "Productivité accrue",
      "Reporting amélioré",
      "Décisions plus rapides et mieux informées",
      "Automatisation de processus",
      "Plan d'action individuel",
      "Certificat EISG",
    ],
    cta: "Explorer les Sessions Augmentées",
    cohort: "Mars / Avril 2027",
    // Joburg context — diverse executives networking in premium lobby
    image: "https://customer-assets.emergentagent.com/job_ai-governance-hub-33/artifacts/m62m27fa_209b6e46-1dc1-4e8a-905c-2942f9b6c075.png",
  },
];

export const COHORTS = [
  {
    period: "Août / Septembre 2026",
    location: "Johannesburg",
    programme: "Programme Phare",
    subtitle: "Pilotage de la Transformation Digitale et de l'IA",
    programmeId: "phare",
  },
  {
    period: "Fin Novembre 2026",
    location: "Cape Town",
    programme: "AI Executive Command",
    subtitle: "Sommet décisionnel des dirigeants",
    programmeId: "command",
  },
  {
    period: "Mars / Avril 2027",
    location: "Johannesburg",
    programme: "Sessions Augmentées",
    subtitle: "Parcours Métiers IA",
    programmeId: "augmentees",
  },
];

export const ADVISORY_AREAS = [
  "Diagnostic de maturité IA",
  "Stratégie IA et feuille de route",
  "Gouvernance de l'IA",
  "Architecture de données",
  "Conduite du changement",
  "Exécution et suivi",
  "Ateliers dirigeants",
  "Séminaires in-house",
  "Formations sur mesure",
  "Co-développement de solutions",
];

export const EXPERIENCE_ITEMS = [
  { title: "Environnement de haut niveau", desc: "Hôtels et espaces de séminaires premium à Johannesburg et Cape Town." },
  { title: "Supports pédagogiques", desc: "Manuels, templates exécutifs, outils opérationnels et frameworks décisionnels." },
  { title: "Pauses café et déjeuners", desc: "Restauration premium incluse, propice au networking entre dirigeants." },
  { title: "Certificat EISG", desc: "Certification exécutive remise à l'issue de chaque programme." },
  { title: "Réseau et communauté", desc: "Accès à la communauté EISG Alumni — dirigeants africains de référence." },
  { title: "Coaching et mentoring", desc: "Sessions individuelles pour aligner votre feuille de route exécutive." },
  { title: "Cas pratiques africains", desc: "Études de cas issues d'institutions publiques et privées du continent." },
  { title: "Support visa et logistique", desc: "Lettres officielles, hébergement, transferts — pris en charge par l'équipe EISG." },
  { title: "Expériences culturelles", desc: "Dîners signature, visites institutionnelles, immersion sud-africaine." },
  { title: "Sécurité et confort", desc: "Standards exécutifs internationaux pour chaque cohorte." },
];

export const REG_STEPS = [
  { num: "01", label: "Pré-inscription" },
  { num: "02", label: "Validation" },
  { num: "03", label: "Facture" },
  { num: "04", label: "Acompte 50%" },
  { num: "05", label: "Solde" },
  { num: "06", label: "Confirmation finale" },
];

export const BD_SECTORS = [
  { title: "Secteur public", desc: "Ministères, agences, collectivités, institutions de régulation." },
  { title: "Mines & ressources", desc: "Opérateurs miniers, raffineries, énergie, infrastructures critiques." },
  { title: "Agriculture & agro-industrie", desc: "Filières agricoles, transformation, climate-smart agriculture." },
  { title: "Banque & finance", desc: "Banques commerciales, microfinance, assurance, marchés de capitaux." },
  { title: "Santé & social", desc: "Hôpitaux, programmes sociaux, ONG, organisations multilatérales." },
  { title: "Industrie & services", desc: "Manufacturing, télécoms, distribution, services aux entreprises." },
];

export const BD_INSIGHTS = [
  { tag: "AI Governance", title: "Pourquoi la gouvernance de l'IA est la nouvelle gouvernance d'entreprise en Afrique", date: "Février 2026", excerpt: "Les conseils d'administration africains doivent intégrer l'IA comme un risque stratégique de premier rang." },
  { tag: "Data Intelligence", title: "Du dashboard à la décision : 5 erreurs classiques à éviter", date: "Janvier 2026", excerpt: "Construire des systèmes de décision exécutifs qui changent réellement les arbitrages." },
  { tag: "Sustainability", title: "ESG minier : convertir les engagements en performance mesurable", date: "Décembre 2025", excerpt: "Un cadre opérationnel pour mesurer l'impact social et environnemental." },
];
